import React, { useState, ReactNode } from 'react';
import { AlertConfig } from '../../types/AlertConfig';
import styles from './PortalPharmaceuticalLayout.module.css';

interface PortalPharmaceuticalLayoutProps {
  children: ReactNode;
}

const PortalPharmaceuticalLayout: React.FC<PortalPharmaceuticalLayoutProps> = ({ children }) => {
  const [configAlert] = useState<AlertConfig | null>(null);

  return (
    <div className={styles.BgTop}>
      <main id="portal-patient-login">
        { children }
      </main>
    </div>
  );
};

export default PortalPharmaceuticalLayout;
